import { useQuery } from '@apollo/client/react';

import { AvalaraTaxItemCode, SalesTaxDocument } from '@graphql/platform';

import { useSharedCheckoutContext } from '@root/components/checkout/context';

export const useStorageTaxRate = () => {
  const {
    flowState: { values },
  } = useSharedCheckoutContext();
  const zip = values.zip;

  return (
    useQuery(SalesTaxDocument, {
      variables: {
        zipCode: zip!,
        avalaraItemCode: AvalaraTaxItemCode.Storage,
      },
      skip: !zip,
    }).data?.salesTax.percent ?? 0
  );
};
